import axios from "axios";
import { axiosError } from "./axiosError";
import { getToken } from "../utility/sessionStorage";

const axiosInstance = axios.create({
    //baseURL: 'http://localhost:8000/api/admin',
    timeout: 30000,
    headers: { 'X-Custom-Header': 'admin-panel' }
});

// export const getCsrfCookie = () => {
//   return instance.get('/sanctum/csrf-cookie');
// };
axiosInstance.interceptors.request.use(
    async config => {
        config.baseURL = window.location.origin + '/api/admin'
        // Retrieve the token from your storage mechanism
        const token = getToken()
        // const token = Cookies.get('token');

        if (token) {
            console.log('token', token);
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    },
);
axiosInstance.interceptors.response.use(
    res => {
        return res?.data;
    },
    err => axiosError(err),
);
export { axiosInstance }
